import { HighlightedText } from '@/app/components/HighlightedText';
import { getPath } from '@/consts/paths';
import type { GlobalSearchAnnouncementsItem } from '@/types/globalSearchApiTypes';
import { SearchItemTitle } from '../SearchItemTitle';
import { SearchItemWrapper } from '../SearchItemWrapper';
import MessagesIcon from '/public/icons/messages.svg';

interface AnnouncementsItemProps {
  item: GlobalSearchAnnouncementsItem;
}

export const AnnouncementsItem = ({ item }: AnnouncementsItemProps) => {
  return (
    <SearchItemWrapper href={getPath(item.redirect_url)}>
      <div className="flex items-center gap-2">
        <MessagesIcon className="w-5 h-5 text-black flex-shrink-0 self-start mt-1 max-md:mt-1.5 max-md:mx-1.5" />
        <div className="flex flex-col gap-1 min-w-0">
          <SearchItemTitle truncate>{item.title}</SearchItemTitle>
          <div className="flex gap-1 max-md:flex-wrap">
            {item.category_name && (
              <p className="text-body-small text-black !leading-[140%] whitespace-nowrap max-md:whitespace-normal">
                <span className="text-body-small text-grey-700 pr-[2px]">Category:</span>
                <HighlightedText>{item.category_name}</HighlightedText>;
              </p>
            )}
            <p className="text-body-small text-grey-700 !leading-[140%] truncate">
              <HighlightedText>{item.detail}</HighlightedText>
            </p>
          </div>
        </div>
      </div>
    </SearchItemWrapper>
  );
};
